export default __webpack_public_path__ + "static/media/NAPA AAG 2022 Launch Brochure-EN-20201204-online.e1c1c9bd.pdf";